export const SUPPORTED_LOCALES = [
  'de',
  'es-ES',
  'es-LA',
  'fr',
  'id',
  'it',
  'ja',
  'ko',
  'nl',
  'pl',
  'pt-BR',
  'pt-PT',
  'ru',
  'th',
  'tr',
  'zh-CN',
  'zh-TW',
];

// TODO: find a better way to map locale to related messages file, currently hard code for es, pt and zh
export function convertLocale(locale: string): string {
  if (SUPPORTED_LOCALES.includes(locale)) return locale;
  if (locale === 'es') return 'es-ES';
  if (locale === 'pt') return 'pt-BR';
  if (locale === 'zh') return 'zh-CN';
  if (locale.length > 2) {
    const newLocale = locale.slice(0, 2);
    return convertLocale(newLocale);
  }
  return locale;
}
